export const CHAT_ATTACH_EVENT = 'brainstormy-chat-attach';

/** Attach the open note or doc to the room chat, or clear it. */
export function publishChatAttachment(attachment) {
  window.dispatchEvent(new CustomEvent(CHAT_ATTACH_EVENT, {
    detail: attachment || null,
  }));
}
